'use client';

import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import DomainCheckWarning from '@/containers/auth/components/DomainCheckWarning';
type Props = {
  children: ReactNode;
};
export default function Layout({
  children
}: Readonly<Props>): JSX.Element {
  return <>
      <Stack sx={{
      flex: 1,
      position: 'relative',
      pb: '72px',
      pt: {
        xs: '72px',
        md: 0
      },
      minHeight: '100vh',
      bgcolor: 'common.white'
    }} data-sentry-element="Stack" data-sentry-source-file="layout.tsx">
        {children}
      </Stack>

      <DomainCheckWarning fullWidth data-sentry-element="DomainCheckWarning" data-sentry-source-file="layout.tsx" />
    </>;
}